module.exports = __webpack_public_path__ + "static/media/launch.dfb33719.mp3";